import { useEffect, useState } from 'react';
import { CheckCircle, XCircle, AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from './ui/alert';

export const BrowserCheck = ({ t }) => {
  const [browserInfo, setBrowserInfo] = useState({
    isSupported: null,
    browserName: '',
    checked: false,
  });

  useEffect(() => {
    // Detect browser
    const userAgent = navigator.userAgent;
    let browserName = 'Unknown';
    let isSupported = false;

    if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
      browserName = 'Google Chrome';
      isSupported = true;
    } else if (userAgent.includes('Edg')) {
      browserName = 'Microsoft Edge';
      isSupported = true;
    } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
      browserName = 'Safari';
      isSupported = true;
    } else if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
      browserName = 'Opera';
      isSupported = true;
    } else if (userAgent.includes('Firefox')) {
      browserName = 'Firefox';
      isSupported = false;
    }

    // Also check for actual Web Speech API support
    const hasWebSpeechAPI = !!(window.SpeechRecognition || window.webkitSpeechRecognition);
    
    setBrowserInfo({
      isSupported: hasWebSpeechAPI && isSupported,
      browserName,
      checked: true,
      hasAPI: hasWebSpeechAPI,
    });
  }, []);

  if (!browserInfo.checked) {
    return null;
  }

  if (browserInfo.isSupported) {
    return (
      <Alert className="border-green-500/30 bg-green-500/5" data-testid="browser-check-success">
        <CheckCircle className="h-4 w-4 text-green-600 dark:text-green-400" />
        <AlertTitle className="text-green-700 dark:text-green-300">
          {t('browser_check_supported')}
        </AlertTitle>
        <AlertDescription className="text-green-600 dark:text-green-400">
          {t('browser_check_supported_desc').replace('{browser}', browserInfo.browserName)}
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <Alert variant="destructive" data-testid="browser-check-error">
      <XCircle className="h-4 w-4" />
      <AlertTitle>{t('browser_check_not_supported')}</AlertTitle>
      <AlertDescription>
        {browserInfo.browserName === 'Firefox' 
          ? t('browser_check_firefox_msg')
          : t('browser_check_not_supported_desc')
        }
        <br />
        <span className="font-medium mt-1 inline-block">
          {t('browser_check_recommendation')}
        </span>
      </AlertDescription>
    </Alert>
  );
};
